import { headerAndFooter } from '@config';
import AiWrite from 'src/views/ai-write';
import { ParagraphStyleView as ReactParagraphStylesView } from 'src/views/menus/text';
import aiCtaTemplate from './ai-cta-template.hbs';
import { aiWrite as aiWriteFeature } from 'src/services/features';

const BannersView = require('./banners');
const TextThumbnailView = require('../components/thumbnail/text');
const HeadingThumbnailView = require('../components/thumbnail/heading');
const humps = require('../../../utils/humps');
const BaseView = require('../components/common/common-component');
const CompanyFactory = require('../../../factory/company').instance;
const EditorFacade = require('../../../facade/editor/editor');
const DesignFacade = require('../../../facade/design/design');
const AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/view'), BaseView.extend({
  type: 'text',
  memberType: ['text', 'details'],
  uploadViewKey: 'text-import',
  headingViews: [],
  defaultTextViews: [],
  listening: false,

  events: {
    ...BaseView.prototype.events,
    'click .ai-write-cta button': 'renderAIApp'
  },

  isHeaderAndFooterEnabled: function () {
    return [
      headerAndFooter.main.layer,
      headerAndFooter.header.layer,
      headerAndFooter.footer.layer
    ].includes(DesignFacade.canvas.getCurrentLayerName());
  },

  searchKeyupEvent: function (event) {
    const val = $(event.target).val();
    const $wrapper = this.$el.find('.' + this.selectedTab.key).find('.antiscroll-wrap');

    $wrapper.find('.thumbnail-wrapper > li, .thumbnail').each(function () {
      const $this = $(this);
      const content = $this.find('span.name').html() ||
        $this.find('a.folder-name').html() ||
        $this.find('.text span').html() || '';

      content && $this.css('display', '');
      content.toLowerCase().indexOf(val.toLowerCase()) === -1 && $this.hide();
    });

    this.embededImportView && this.embededImportView.views[this.type].masonryReload();
  },

  isAlreadyThere: function () {
    return !!this.$el.find('.tab-content.text').length;
  },

  refresh: function () {
    BaseView.prototype.refresh.call(this);

    this.$headerLinks.filter('[data-key=add]').is('.active') && this.initAddView();
    this.$headerLinks.filter('[data-key=banners]').is('.active') && this.bannersView.refresh();
  },

  render: async function () {
    await BaseView.prototype.render.call(this);

    const features = await CompanyFactory.getCompanyItems('features');
    const isTextBannerEnabled = !!features?.white_label?.includes?.('show_text_banners');
    !isTextBannerEnabled && this.$headerLinks.filter('[data-key=banners]').addClass('hidden');

    const $addTab = this.$headerLinks.filter('[data-key=add]');
    if (this.isEnterprise) {
      this.isKW
        ? this.$headerLinks.filter('[data-key=add]').trigger('click')
        : BaseView.prototype.checkEmptyLibrary.call(this, $addTab);
    } else {
      $addTab.trigger('click');
    }
  },

  show: function () {
    BaseView.prototype.show.call(this);

    if (!this.listening) {
      this.listening = true;

      EditorFacade.on('select', () => {
        this.$el.is(':visible') && this.refreshHeadingSelection();
      });

      DesignFacade.on('text.update.heading', () => {
        this.$el.is(':visible') && this.refreshHeadingSelection();
      });
    }
  },

  initAddView: function () {
    BaseView.prototype.initAddView.call(this);

    this.renderDefaultText();
    this.initDefaultText();
    this.renderAICta();
    this.renderHeadings();
  },

  renderDefaultText: function () {
    const $wrapper = this.$el.find('.add > .top-content');

    this.defaultTextViews = _.map(INKIVE.C.TextDefault, function (data, index) {
      const $thumbnailView = $('<div>').addClass('thumbnail').appendTo($wrapper);
      const storedData = localStorage.getItem('default_text_' + index);

      return new TextThumbnailView({
        el: $thumbnailView,
        data: _.extend(humps.decamelizeKeys(data), JSON.parse(storedData))
      });
    }, this);
  },

  renderAICta: async function () {
    if (!aiWriteFeature.isPreviewAllowed()) return;

    const userHaveAccess = INKIVE.Helpers.isDesygnerProject()
      ? INKIVE.UserInfoFactory.isProPaidUser()
      : INKIVE.UserInfoFactory.isBusinessUser() &&
      INKIVE.UserInfoFactory.hasContentPlan();

    const allowUserUpselling = INKIVE.C.FEATURE_FLAG?.users?.includes('allows_user_upselling');

    const showUpgradingPoint = !userHaveAccess && allowUserUpselling;

    const html = aiCtaTemplate({
      showIcon: showUpgradingPoint
    });
    const template = document.createElement('template');
    template.innerHTML = html.trim();

    const wrapperChild = document.querySelector('.add > .top-content');
    const wrapper = wrapperChild.parentElement;
    wrapper.insertBefore(template.content.firstChild, wrapperChild);
  },

  renderAIApp: async function () {
    const workspace = await INKIVE.CompanyFactory.getCompanyData();
    const workspaceAllowsUpselling = workspace?.features?.users?.includes('allows_user_upselling');
    const isProPaidUser = INKIVE.UserInfoFactory.isProPaidUser();
    const isWorkspaceUser = INKIVE.UserInfoFactory.isBusinessUser();
    const isWorkspaceAllowed = isWorkspaceUser && !workspace.is_customisation_preview;

    if (!INKIVE.UserInfoFactory.hasContentPlan() && workspaceAllowsUpselling) {
      INKIVE.Helpers.displaySubscriptionModal(null, 'content2');
      return;
    }

    (isProPaidUser || isWorkspaceAllowed)
      ? AiWrite.mountApp()
      : INKIVE.Helpers.displaySubscriptionModal();
  },

  renderHeadings: function () {
    if (this.isHeaderAndFooterEnabled()) return;

    const $wrapper = this.$el.find('.add > .top-content');
    const $list = $('<ul>').addClass('thumbnail-wrapper sidebar-headings').appendTo($wrapper);
    this.headingViews = [];

    for (let heading = 1; heading < 6; heading++) {
      this.headingViews.push(new HeadingThumbnailView({
        heading, el: $('<li>').addClass('thumbnail').appendTo($list)
      }));
    }

    this.refreshHeadingSelection();
  },

  refreshHeadingSelection: function () {
    const headings = [...document.querySelectorAll('#svgcontent .element.selected[data-heading]')]
      .map(e => parseInt(e.getAttribute('data-heading')))
      .filter((value, index, self) => value && self.indexOf(value) === index);

    for (const headingView of this.headingViews) {
      headingView.$el.toggleClass('applied', headings.includes(headingView.heading));
    }
  },

  initDefaultText: function () {
    const defaultTextsViews = this.defaultTextViews;
    const lastText = _.last(this.defaultTextViews);
    const message = INKIVE.TranslateHelper.translate('tool.text.click');
    const isFirstTime = !localStorage.getItem('text_hint');

    localStorage.setItem('text_hint', true);
    initEventListeners.call(this);
    isFirstTime || typeAll();
    isFirstTime && lastText.type(message).then(function () {
      lastText.erase().then(typeAll);
    });

    function typeAll () {
      _.each(defaultTextsViews, function (textView) {
        textView.type().then(function () {
          textView.$el.find('a.toggle-options').addClass('show');
          textView.endTyping();
        });
      });
    }

    function initEventListeners () {
      _.each(defaultTextsViews, function (textView) {
        const textChangeEvent = _.bind(this.textChangeEvent, this, textView);
        textView.on('change', textChangeEvent);
      }, this);
    }
  },

  textChangeEvent: function (textView) {
    const data = textView.getTextData('_');
    const id = _.findIndex(this.defaultTextViews, textView);

    localStorage.setItem('default_text_' + id, JSON.stringify(data));
  },

  initBannersView: function () {
    const $view = $('<div></div>').addClass('image-list');

    this.$el.find('.tab-content > .banners').append($view);
    this.bannersView = new BannersView({ el: $view });
    this.registerTabView('banners', this.bannersView);
    this.bannersView.show();
  },

  initParagraphStylesView: (function (isMounted) {
    return () => {
      !isMounted && ReactParagraphStylesView.mountApp();

      isMounted = true;
    };
  })(false),

  updateSearchContainer: function () {
    const isSearchable = this.selectedTab.searchable;

    isSearchable && this.displaySearchContainer(this.$el.find('.search-container'));
  }
}));
